export default function filterListBySearchString<T>(list: T[], searchString: string, elementStringToMatch: (element: T) => string): T[] {
	if (list == null)
		return list;

	// Split the search string into multiple tokens
	const filterTokens = escapeRegExp(searchString).split(' ');

	// For each of the tokens, filter the list to only items with that token. Therefore the item must match ALL of the tokens in the string.
	filterTokens.forEach(token => {
		if (token.length > 0) {
			// Search on word boundary or underscore (which is not normally considered a word boundary)
			const regEx = new RegExp('(\\b|_)' + token, 'i');
			list = list.filter((item) => regEx.test(elementStringToMatch(item)));
		}
	});

	return list;
}

function escapeRegExp(searchString: string) {
	return searchString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
